import Vue from 'vue';
import Component from 'vue-class-component';
import {Viewport} from '../models/Viewport';
import {Language} from '../models/ProductModels';


@Component({
 props:{
     viewport:{

     }
 }
})
export default class LangDropdown extends Vue {
    viewport:Viewport;
    languageString:string;


    onChange(event:Event){
     this.viewport.handleLanguageChange(Language[this.languageString]);
    }

    created(){
        this.languageString = Language[this.viewport.viewportLanguage];
        //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>",this.languageString);
    }
}